var _rect, _g, _rect2, _rect3, _rect4, _path, _path2, _path3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryCardBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 227,
    viewBox: "0 0 381 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4047_70264",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 381,
    height: 227
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4047_70264)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_4047_70264)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 57.7071,
    y: -14.3809,
    width: 114.427,
    height: 114.427,
    rx: 8.5,
    transform: "rotate(-45 57.7071 -14.3809)",
    stroke: "#DBDBDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -35.2078,
    y: 28,
    width: 294.982,
    height: 151.027,
    rx: 20,
    transform: "rotate(45 -35.2078 28)",
    fill: "#F4FAFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.46695 5.58317C5.73771 4.83777 7.31535 4.85124 8.57321 5.61823L115.175 70.6197C118.642 72.7332 117.119 78.0694 113.059 78.0347L-101.24 76.2054C-105.299 76.1707 -106.731 70.8094 -103.229 68.7553L4.46695 5.58317Z",
    fill: "#F2F6FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-43 85L108 85C113.523 85 118 89.4772 118 95V190C118 195.523 113.523 200 108 200H-43L-43 85Z",
    fill: "url(#paint0_linear_4047_70264)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-42.5 85.5L108 85.5C113.247 85.5 117.5 89.7533 117.5 95V190C117.5 195.247 113.247 199.5 108 199.5H-42.5L-42.5 85.5Z",
    stroke: "#B2B9C0",
    strokeOpacity: 0.42
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 277.121,
    y: 247.33,
    width: 83.7326,
    height: 112.427,
    rx: 7.5,
    transform: "rotate(-45 277.121 247.33)",
    stroke: "#F0F5FC",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 106.707,
    y: 185.809,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 106.707 185.809)",
    stroke: "#EAEAEA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 173.707,
    y: 56.8086,
    width: 35.5002,
    height: 35.5002,
    rx: 8.5,
    transform: "rotate(-45 173.707 56.8086)",
    stroke: "#EAEAEA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 153.5,
    width: 19,
    height: 19,
    rx: 1.5,
    stroke: "#E5E5E5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5,
    y: 153.5,
    width: 19,
    height: 19,
    rx: 1.5,
    stroke: "#E5E5E5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5,
    y: 130.5,
    width: 19,
    height: 19,
    rx: 1.5,
    stroke: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 154H76V161.5C76 161.776 75.7761 162 75.5 162H70.5C70.2239 162 70 161.776 70 161.5V154Z",
    fill: "#EFF4FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95 154H101V161.5C101 161.776 100.776 162 100.5 162H95.5C95.2239 162 95 161.776 95 161.5V154Z",
    fill: "#EFF4FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95 131H101V138.5C101 138.776 100.776 139 100.5 139H95.5C95.2239 139 95 138.776 95 138.5V131Z",
    fill: "#EFF4FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4047_70264",
    x1: 37,
    y1: 100,
    x2: 37.5,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4047_70264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 227,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryCardBackground);
export default __webpack_public_path__ + "static/media/inventory-card-background.bb2df36dd96af6194558179568bbc4d8.svg";
export { ForwardRef as ReactComponent };